import type { AdminQuoteDetail, IssuedQuoteVersion } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDateTime } from '@/shared/lib';
import { ContentCard } from '@/shared/ui';

export interface QuoteRevisionHistoryProps {
  readonly requests: AdminQuoteDetail['revisionRequests'];
  /** 요청이 가리키는 발행본의 차수를 찾는 데 쓴다. */
  readonly versions: readonly IssuedQuoteVersion[];
}

/** 고객 수정 요청 이력(견적 설계 §9-5) — 어느 발행본에 대한 요청인지와 사유. */
export const QuoteRevisionHistory = ({
  requests,
  versions,
}: QuoteRevisionHistoryProps): ReactElement => (
  <ContentCard title="수정 요청 이력">
    {requests.length === 0 ? (
      <p className="text-sm text-muted-foreground">수정 요청이 없습니다.</p>
    ) : (
      <ul className="flex flex-col gap-3">
        {requests.map((request) => {
          const version = versions.find((candidate) => candidate.id === request.versionId);

          return (
            <li key={request.id} className="rounded-xl bg-foreground/[0.03] p-3 text-sm">
              <p className="text-xs text-muted-foreground">
                {version === undefined ? '발행본' : `${version.version}차 발행본`} ·{' '}
                {formatDateTime(request.createdAt)}
              </p>
              <p className="mt-1 whitespace-pre-wrap wrap-anywhere">{request.reason}</p>
            </li>
          );
        })}
      </ul>
    )}
  </ContentCard>
);
